import { useTranslate } from "ra-core";
import { useCallback } from "react";
import { stageLabelFor } from "../domain/deals/stageModel";
import { useDealStages } from "./useDealStages";

/** The stage label: the owner's once renamed (both languages); a built-in stage with its default label is translated;
 * a deleted stage shows its translation, else its value. */
export const useStageLabel = () => {
  const translate = useTranslate();
  const stages = useDealStages();
  return useCallback(
    (value: string) => stageLabelFor(stages, value, translate),
    [translate, stages],
  );
};
